import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
export const HostSalon = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    aboutYou: '',
    inspiration: '',
    attendees: '',
    existingCommunity: '',
    communityDescription: '',
    promotionPlan: '',
    experience: '',
    eventDescription: '',
    engagementPlan: '',
    orientationAvailability: '',
    documentationWillingness: '',
    agreement: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formspree.io/f/xnngonyv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: '',
          role: '',
          aboutYou: '',
          inspiration: '',
          attendees: '',
          existingCommunity: '',
          communityDescription: '',
          promotionPlan: '',
          experience: '',
          eventDescription: '',
          engagementPlan: '',
          orientationAvailability: '',
          documentationWillingness: '',
          agreement: ''
        });
        setIsSubmitted(true);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (err) {
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSubmitted) {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-1592">
        <div className="container mx-auto px-4 py-16" data-id="element-1593">
          <div className="max-w-3xl mx-auto" data-id="element-1594">
            <div className="bg-white p-8 rounded-lg border-2 border-gray-300 text-center" data-id="element-1595">
              <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-1596">
                Thank you for applying to host a Networking Salon!
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-1597">
                Your submission has been received, and our team will review it
                carefully. If selected, you'll receive hosting guidelines,
                support resources, and a short orientation session to help you
                plan your event.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-1598">
                Together, we'll keep building spaces where connections turn into
                real opportunities.
              </p>
              <a href="https://wa.link/nc2jpo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-1599">
                <span className="mr-2" data-id="element-1600">💬</span>
                Chat With Us on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white min-h-screen" data-id="element-1601">
      <section className="relative py-16 border-b border-gray-200" data-id="element-1602">
        <div className="absolute inset-0 z-0" data-id="element-1603">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="Host a Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-1604" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-1605"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-1606">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1607">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-1608">
              Host a Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-1609">
              Create meaningful connections in your community
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-1610">
        <div className="container mx-auto px-4" data-id="element-1611">
          <div className="max-w-3xl mx-auto" data-id="element-1612">
            <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-1613">
              <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1614">
                Host a Networking Salon — Application Form
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-1615">
                We're excited that you'd like to host a Networking Salon!
                Hosting is more than putting people in a room — it's about
                curating meaningful conversations, creating safe spaces for
                connection, and upholding the values of The Networking Salon.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-1616">
                This short form helps us understand your readiness, your
                audience, and how you plan to make your salon special.
              </p>
              {error && <div className="bg-gray-100 border-2 border-gray-400 text-gray-800 p-4 rounded-md mb-6" data-id="element-1617">
                  {error}
                </div>}
              <form onSubmit={handleSubmit} className="space-y-8" data-id="element-1618">
                <div className="space-y-6" data-id="element-1619">
                  <div data-id="element-1620">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-1621">
                      Section 1: Host Information
                    </h3>
                    <div className="space-y-4" data-id="element-1622">
                      <div data-id="element-1623">
                        <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-1624">
                          Full Name <span className="text-gray-500" data-id="element-1625">*</span>
                        </label>
                        <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1626" />
                      </div>
                      <div data-id="element-1627">
                        <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-1628">
                          Email Address <span className="text-gray-500" data-id="element-1629">*</span>
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1630" />
                      </div>
                      <div data-id="element-1631">
                        <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-1632">
                          Phone Number (WhatsApp Preferred){' '}
                          <span className="text-gray-500" data-id="element-1633">*</span>
                        </label>
                        <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1634" />
                      </div>
                      <div data-id="element-1635">
                        <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-1636">
                          City, Country <span className="text-gray-500" data-id="element-1637">*</span>
                        </label>
                        <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1638" />
                      </div>
                      <div data-id="element-1639">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-1640">
                          What best describes you?{' '}
                          <span className="text-gray-500" data-id="element-1641">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-1642">
                          {['Community Builder', 'Event Organizer', 'Business Owner / Founder', 'Professional / Creative', 'Student / Young Leader', 'Other'].map(option => <div key={option} className="flex items-center" data-id="element-1643">
                              <input type="radio" id={`role-${option}`} name="role" value={option} checked={formData.role === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1644" />
                              <label htmlFor={`role-${option}`} className="text-gray-700" data-id="element-1645">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-1646">
                        <label htmlFor="aboutYou" className="block text-gray-700 font-medium mb-1" data-id="element-1647">
                          Tell us a bit about yourself{' '}
                          <span className="text-gray-500" data-id="element-1648">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-1649">
                            Include your background, what you do, and what
                            drives your interest in community building.
                          </span>
                        </label>
                        <textarea id="aboutYou" name="aboutYou" value={formData.aboutYou} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1650" />
                      </div>
                    </div>
                  </div>
                  <div data-id="element-1651">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-1652">
                      Section 2: Event Vision & Reach
                    </h3>
                    <div className="space-y-4" data-id="element-1653">
                      <div data-id="element-1654">
                        <label htmlFor="inspiration" className="block text-gray-700 font-medium mb-1" data-id="element-1655">
                          What inspired you to host a Networking Salon?{' '}
                          <span className="text-gray-500" data-id="element-1656">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-1657">
                            We want to understand your motivation — what excites
                            you about this platform?
                          </span>
                        </label>
                        <textarea id="inspiration" name="inspiration" value={formData.inspiration} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1658" />
                      </div>
                      <div data-id="element-1659">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-1660">
                          Estimated Number of Attendees{' '}
                          <span className="text-gray-500" data-id="element-1661">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-1662">
                          {['20–50', '51–100', '101–200', 'More than 200'].map(option => <div key={option} className="flex items-center" data-id="element-1663">
                                <input type="radio" id={`attendees-${option}`} name="attendees" value={option} checked={formData.attendees === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1664" />
                                <label htmlFor={`attendees-${option}`} className="text-gray-700" data-id="element-1665">
                                  {option}
                                </label>
                              </div>)}
                        </div>
                      </div>
                      <div data-id="element-1666">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-1667">
                          Do you have an existing community or audience you can
                          invite? <span className="text-gray-500" data-id="element-1668">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-1669">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-1670">
                              <input type="radio" id={`existingCommunity-${option}`} name="existingCommunity" value={option} checked={formData.existingCommunity === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1671" />
                              <label htmlFor={`existingCommunity-${option}`} className="text-gray-700" data-id="element-1672">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.existingCommunity === 'Yes' && <div data-id="element-1673">
                          <label htmlFor="communityDescription" className="block text-gray-700 font-medium mb-1" data-id="element-1674">
                            If yes, please describe your community or network
                            <span className="block text-sm text-gray-500" data-id="element-1675">
                              Who are they? What connects them? How do you
                              normally engage with them?
                            </span>
                          </label>
                          <textarea id="communityDescription" name="communityDescription" value={formData.communityDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1676" />
                        </div>}
                      <div data-id="element-1677">
                        <label htmlFor="promotionPlan" className="block text-gray-700 font-medium mb-1" data-id="element-1678">
                          How will you promote the event to ensure attendance?{' '}
                          <span className="text-gray-500" data-id="element-1679">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-1680">
                            Share your plan — social media, word of mouth,
                            partnerships, campus networks, etc.
                          </span>
                        </label>
                        <textarea id="promotionPlan" name="promotionPlan" value={formData.promotionPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1681" />
                      </div>
                      <div data-id="element-1682">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-1683">
                          Do you have experience organizing or co-hosting
                          events? <span className="text-gray-500" data-id="element-1684">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-1685">
                          {["Yes, I've organized events before", "Not yet, but I'm confident I can handle it"].map(option => <div key={option} className="flex items-center" data-id="element-1686">
                              <input type="radio" id={`experience-${option}`} name="experience" value={option} checked={formData.experience === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1687" />
                              <label htmlFor={`experience-${option}`} className="text-gray-700" data-id="element-1688">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.experience === "Yes, I've organized events before" && <div data-id="element-1689">
                          <label htmlFor="eventDescription" className="block text-gray-700 font-medium mb-1" data-id="element-1690">
                            If yes, briefly describe one event you've hosted or
                            contributed to
                          </label>
                          <textarea id="eventDescription" name="eventDescription" value={formData.eventDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1691" />
                        </div>}
                    </div>
                  </div>
                  <div data-id="element-1692">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-1693">
                      Section 3: Alignment & Commitment
                    </h3>
                    <div className="space-y-4" data-id="element-1694">
                      <div data-id="element-1695">
                        <label htmlFor="engagementPlan" className="block text-gray-700 font-medium mb-1" data-id="element-1696">
                          The Networking Salon is about meaningful connection,
                          not just attendance. How will you ensure your guests
                          engage deeply and not just "show up"?{' '}
                          <span className="text-gray-500" data-id="element-1697">*</span>
                        </label>
                        <textarea id="engagementPlan" name="engagementPlan" value={formData.engagementPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-1698" />
                      </div>
                      <div data-id="element-1699">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-1700">
                          Will you be available for a short orientation session
                          before hosting?{' '}
                          <span className="text-gray-500" data-id="element-1701">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-1702">
                          {['Yes, absolutely', "I'll need advance notice", 'Maybe, depending on timing'].map(option => <div key={option} className="flex items-center" data-id="element-1703">
                              <input type="radio" id={`orientationAvailability-${option}`} name="orientationAvailability" value={option} checked={formData.orientationAvailability === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1704" />
                              <label htmlFor={`orientationAvailability-${option}`} className="text-gray-700" data-id="element-1705">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-1706">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-1707">
                          Are you willing to document your salon (photos, short
                          recap, highlights) and share them with our team for
                          visibility? <span className="text-gray-500" data-id="element-1708">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-1709">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-1710">
                              <input type="radio" id={`documentationWillingness-${option}`} name="documentationWillingness" value={option} checked={formData.documentationWillingness === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1711" />
                              <label htmlFor={`documentationWillingness-${option}`} className="text-gray-700" data-id="element-1712">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-1713">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-1714">
                      Final Declaration
                    </h3>
                    <div data-id="element-1715">
                      <label className="block text-gray-700 font-medium mb-1" data-id="element-1716">
                        I understand that hosting a Networking Salon means
                        representing the brand's values of collaboration,
                        respect, and authenticity.{' '}
                        <span className="text-gray-500" data-id="element-1717">*</span>
                      </label>
                      <div className="space-y-2" data-id="element-1718">
                        {['Yes, I understand and agree', "I'd like to learn more first"].map(option => <div key={option} className="flex items-center" data-id="element-1719">
                            <input type="radio" id={`agreement-${option}`} name="agreement" value={option} checked={formData.agreement === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1720" />
                            <label htmlFor={`agreement-${option}`} className="text-gray-700" data-id="element-1721">
                              {option}
                            </label>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2" data-id="element-1722">
                  <Button type="submit" disabled={isSubmitting} className="w-full py-3" data-id="element-1723">
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>;
};